import { useParams, Link } from "react-router-dom";
import { articles, categories } from "@/mocks/articles";
import { siteInfo } from "@/mocks/articles";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ArticleCard from "@/components/base/ArticleCard";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeCategory = categories.find((c) => c.slug === slug);

  const filteredArticles = activeCategory
    ? articles.filter((a) => a.category === activeCategory.slug)
    : articles;

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            {/* Breadcrumb */}
            <Breadcrumb
              items={[
                { label: "首页", to: "/" },
                ...(activeCategory
                  ? [{ label: activeCategory.name }]
                  : [{ label: "全部分类" }]),
              ]}
            />

            {/* Page Header */}
            <div className="mb-10">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
                {activeCategory ? activeCategory.name : "全部分类"}
              </h1>
              {activeCategory && (
                <p className="text-foreground-600 max-w-2xl">
                  {activeCategory.description}
                </p>
              )}
            </div>

            {/* Category Tabs */}
            <div className="mb-10 border-b border-background-200/70 pb-1 overflow-x-auto">
              <div className="flex items-center gap-1 min-w-max">
                <Link
                  to="/category/gurien-xiangchu"
                  className={`px-1 py-1`}
                >
                  <span
                    className={`inline-block px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                      slug === "gurien-xiangchu" || !activeCategory
                        ? "bg-primary-500 text-white"
                        : "text-foreground-600 hover:text-primary-500 hover:bg-primary-50"
                    }`}
                  >
                    {categories[0]?.name || "闺蜜相处"}
                  </span>
                </Link>
                {categories.slice(1).map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-1 py-1`}
                  >
                    <span
                      className={`inline-block px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                        slug === cat.slug
                          ? "bg-primary-500 text-white"
                          : "text-foreground-600 hover:text-primary-500 hover:bg-primary-50"
                      }`}
                    >
                      {cat.name}
                    </span>
                  </Link>
                ))}
              </div>
            </div>

            {/* Articles Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {filteredArticles.length > 0 ? (
                filteredArticles.map((article) => (
                  <ArticleCard key={article.slug} article={article} />
                ))
              ) : (
                <div className="col-span-full text-center py-20">
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mx-auto mb-4">
                    <i className="ri-inbox-line text-2xl"></i>
                  </div>
                  <p className="text-foreground-600">该分类下暂无文章</p>
                </div>
              )}
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}